import React from 'react'
import '../styles/about_us.css'
import { Faqs } from '../common/questions/faqs'
import PartnersSlider from '../common/partners_slider'


function AboutUs() {
return (
<>
    <h2 className="page_title">About us</h2>

    {/* ====================================== more than 14 year section ==================================== */}
    <div className="row">
        <div className="col-6">
            <div className='more_than'>We Have More Than 14 Years Of <span>Experience</span></div>
            <div className="row years_desc col-10">
                <div className="col-4">
                    <div className="d-flex flex-column">
                        {/*==========> desc item <========== */} <div className="row desc_item">
                            <div className="col-2"><img src="/assets/images/white/correct.svg" className={`mx-1`}
                                    alt="" /></div>
                            <div className="col-9">
                                <div className="item_title">Best Produts</div>
                                <div className="desc">We provide the finest types of products in various parts of Egypt
                                </div>
                            </div>
                    </div>
                    {/*==========> desc item <========== */} <div className="row desc_item">
                        <div className="col-2"><img src="/assets/images/white/correct.svg" className={`mx-1`}
                                alt="" /></div>
                        <div className="col-9">
                            <div className="item_title">Competitive Price</div>
                            <div className="desc">We have the best prices and the finest products you can trust</div>
                        </div>
                </div>
                {/*==========> desc item <========== */} <div className="row desc_item">
                    <div className="col-2"><img src="/assets/images/white/correct.svg" className={`mx-1`}
                            alt="" /></div>
                    <div className="col-9">
                        <div className="item_title">Wide Delivery Area</div>
                        <div className="desc">We have many services to deliver products quickly</div>
                    </div>
            </div>
        </div>
    </div>
    <div className="col-8">
        <div className="d-flex flex-column desc-column">
            <div className="desc my-2">We have great experience over the years in trading our products </div>
            <div className="desc my-2">We providing the latest methods of exporting them and competing in the world
                markets </div>
            <div className="desc my-2">We provide the finest types of products in various parts of Egypt Lorem ipsum
                dolor sit</div>
        </div>
    </div>
    </div>
    </div>
    <div className="col-6 ">
        <div className="img-partent">
            <img src="/assets/images/white/14.png" className={`mx-1`} alt="" />
        </div>
    </div>
    </div>

    {/* ====================================== 3 carts section ==================================== */}
    <section className='row'>
        <div className="col-4">
            <div className="mx-3">
                <div className="about_cart">
                    <div className="img_container">
                        <img src="/assets/images/white/about_products.svg" className={`mx-1`} alt="" />
                    </div>
                    <div className="cart_title">Best products </div>
                    <div className="cart_desc w-50 text-center">We offer the best of all kinds of products, and we
                        export them to all over the world</div>
                </div>
            </div>
        </div>
        <div className="col-4">
            <div className="mx-3">
                <div className="about_cart">
                    <div className="img_container">
                        <img src="/assets/images/white/packaging.svg" className={`mx-1`} alt="" />
                    </div>
                    <div className="cart_title">Best packaging </div>
                    <div className="cart_desc w-50 text-center">We offer the best packaging for all our products that
                        shipped to all over the world</div>
                </div>
            </div>
        </div>
        <div className="col-4">
            <div className="mx-3">
                <div className="about_cart">
                    <div className="img_container">
                        <img src="/assets/images/white/transport.svg" className={`mx-1`} alt="" />
                    </div>
                    <div className="cart_title">Best Transportation</div>
                    <div className="cart_desc w-50 text-center">We ship our products in the latest and safest ways to
                        make sure the products are saved</div>
                </div>
            </div>
        </div>



    </section>

    {/* ====================================== why choose us ==================================== */}
    <section className='choose_us'>
        <div className="choose_img">
            <img src="/assets/images/white/contact_export.svg" className={`mx-1`} alt="" />
        </div>
        <div className="choose_content">
            <h2 className="page_title">why choose us</h2>
            <div className="choose_title">
                We <span>Export Our products </span>
                all Over The World
            </div>
            <div className="choose_desc">
                We have great experience over the years in trading our products and providing the latest methods of
                exporting them and competing in the world markets
            </div>
            <a href="" className='shop_btn'>Shop Now &gt;&gt; </a>
        </div>
    </section>

    {/* ====================================== FAQs ==================================== */}
    <section>
        <div className='more_than'>FAQs</div>
        <Faqs></Faqs>
    </section>

    {/* ====================================== Our Success Partners ==================================== */}
    <section className='choose_us'>
        <div className="choose_img">
            <img src="/assets/images/white/partners.svg" className={`mx-1`} alt="" />
        </div>
        <div className="choose_content">
            <h2 className="page_title">success partners</h2>
            <div className="choose_title">
                Our <span> Success Partners </span></div>
            <div className="choose_desc">
                Our collaborative approach ensures effective relationships, contributing to successful ventures across
                these diverse industries.
            </div>

            <PartnersSlider></PartnersSlider>

        </div>
    </section>

</>
)
}

export default AboutUs
